import { render } from "./partial-card-list-pagination.vue?vue&type=template&id=f5c82b2a&ts=true"
import script from "./partial-card-list-pagination.vue?vue&type=script&lang=ts"
export * from "./partial-card-list-pagination.vue?vue&type=script&lang=ts"

import "./partial-card-list-pagination.vue?vue&type=style&index=0&id=f5c82b2a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__